var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBillingBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_1989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.875 28.875V6.875C6.875 6.14565 7.16473 5.44618 7.68046 4.93046C8.19618 4.41473 8.89565 4.125 9.625 4.125H23.375C24.1043 4.125 24.8038 4.41473 25.3195 4.93046C25.8353 5.44618 26.125 6.14565 26.125 6.875V28.875L22 26.125L19.25 28.875L16.5 26.125L13.75 28.875L11 26.125L6.875 28.875Z",
    stroke: "#0C6CDE",
    strokeWidth: 2.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 11H15.8125C15.2655 11 14.7409 11.2173 14.3541 11.6041C13.9673 11.9909 13.75 12.5155 13.75 13.0625C13.75 13.6095 13.9673 14.1341 14.3541 14.5209C14.7409 14.9077 15.2655 15.125 15.8125 15.125H17.1875C17.7345 15.125 18.2591 15.3423 18.6459 15.7291C19.0327 16.1159 19.25 16.6405 19.25 17.1875C19.25 17.7345 19.0327 18.2591 18.6459 18.6459C18.2591 19.0327 17.7345 19.25 17.1875 19.25H13.75M16.5 19.25V21.3125M16.5 8.9375V11",
    stroke: "#0C6CDE",
    strokeWidth: 2.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_1989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBillingBlue);
export default __webpack_public_path__ + "static/media/Icon_Billing_Blue.e29d6682aaf63c6d887509369a809fdc.svg";
export { ForwardRef as ReactComponent };